export default __webpack_public_path__ + "static/media/Select-Network.af62b702.png";